/**
 * Localization keys constants
 * These keys are used to retrieve translations from the localization system
 */

export const LocalizationKeys = {
  // Common keys
  COMMON_LOADING: "common.loading",
  COMMON_ERROR: "common.error",
  COMMON_SAVE: "common.save",
  COMMON_CANCEL: "common.cancel",
  COMMON_DELETE: "common.delete",
  COMMON_DELETING: "common.deleting",
  COMMON_YES: "common.yes",
  COMMON_EDIT: "common.edit",
  COMMON_BACK: "common.back",
  COMMON_NO_RESULTS: "common.noResults",
  COMMON_VIEW_ALL: "common.viewAll",
  COMMON_RESULT: "common.result",
  COMMON_RESULTS: "common.results",

  // View mode keys
  VIEW_MODE_TOGGLE: "viewMode.toggle",
  VIEW_MODE_GRID: "viewMode.grid",
  VIEW_MODE_LIST: "viewMode.list",

  // Text editor keys
  TEXT_EDITOR_BOLD: "textEditor.bold",
  TEXT_EDITOR_ITALIC: "textEditor.italic",
  TEXT_EDITOR_UNDERLINE: "textEditor.underline",
  TEXT_EDITOR_STRIKETHROUGH: "textEditor.strikethrough",
  TEXT_EDITOR_HEADING: "textEditor.heading",
  TEXT_EDITOR_QUOTE: "textEditor.quote",
  TEXT_EDITOR_LIST: "textEditor.list",
  TEXT_EDITOR_LINK: "textEditor.link",
  TEXT_EDITOR_PLACEHOLDER: "textEditor.placeholder",
  TEXT_EDITOR_PREVIEW: "textEditor.preview",

  // Header keys
  HEADER_SEARCH: "header.search",
  HEADER_NOTIFICATIONS: "header.notifications",
  HEADER_PROFILE: "header.profile",

  // Auth keys
  AUTH_SIGN_IN: "auth.signIn",
  AUTH_SIGN_UP: "auth.signUp",
  AUTH_LOGOUT: "auth.logout",
  AUTH_EMAIL: "auth.email",
  AUTH_PASSWORD: "auth.password",
  AUTH_USERNAME: "auth.username",
  AUTH_PROMPT_MESSAGE: "auth.promptMessage",
  AUTH_PROMPT_TITLE: "auth.promptTitle",
  AUTH_PROMPT_SUBTITLE: "auth.promptSubtitle",
  AUTH_PROMPT_FEATURE_TRACK: "auth.promptFeatureTrack",
  AUTH_PROMPT_FEATURE_REVIEWS: "auth.promptFeatureReviews",
  AUTH_PROMPT_FEATURE_COLLECTIONS: "auth.promptFeatureCollections",
  AUTH_PROMPT_FEATURE_DISCUSS: "auth.promptFeatureDiscuss",
  AUTH_PROMPT_FEATURE_NOTIFICATIONS: "auth.promptFeatureNotifications",
  AUTH_PROMPT_FEATURE_SOCIAL: "auth.promptFeatureSocial",

  // Common keys
  COMMON_CLOSE: "common.close",

  // Profile keys
  PROFILE_OPEN_PROFILE: "profile.openProfile",
  PROFILE_THEME: "profile.theme",
  PROFILE_LANGUAGE: "profile.language",
  PROFILE_SETTINGS: "profile.settings",

  // Menu keys
  MENU_SELECT_THEME: "menu.selectTheme",
  MENU_SELECT_LANGUAGE: "menu.selectLanguage",
  MENU_BACK_TO_MENU: "menu.backToMenu",
  MENU_LANGUAGE_CHANGED: "menu.languageChanged",
  MENU_THEME_CHANGED: "menu.themeChanged",

  // Theme keys
  THEME_LIGHT: "theme.light",
  THEME_DARK: "theme.dark",
  THEME_SYSTEM: "theme.system",

  // Language keys
  LANGUAGE_SYSTEM: "language.system",
  LANGUAGE_RU: "language.ru",
  LANGUAGE_EN: "language.en",
  LANGUAGE_ES: "language.es",
  LANGUAGE_FR: "language.fr",
  LANGUAGE_DE: "language.de",
  LANGUAGE_ZH: "language.zh",
  LANGUAGE_IN: "language.in",
  LANGUAGE_PT: "language.pt",

  // Consume Type keys
  CONSUME_TYPE_UNSPECIFIED: "consumeType.unspecified",
  CONSUME_TYPE_WATCHING: "consumeType.watching",
  CONSUME_TYPE_WATCHED: "consumeType.watched",
  CONSUME_TYPE_TRASH: "consumeType.trash",
  CONSUME_TYPE_DELAYED: "consumeType.delayed",

  // Gender keys
  GENDER_UNSPECIFIED: "gender.unspecified",
  GENDER_MALE: "gender.male",
  GENDER_FEMALE: "gender.female",
  GENDER_OTHER: "gender.other",

  // Content Type keys
  CONTENT_TYPE_UNSPECIFIED: "contentType.unspecified",
  CONTENT_TYPE_MOVIE: "contentType.movie",
  CONTENT_TYPE_BOOK: "contentType.book",
  CONTENT_TYPE_TV_SHOW: "contentType.tvShow",
  CONTENT_TYPE_COMICS: "contentType.comics",
  CONTENT_TYPE_GAME: "contentType.game",

  // Content Status keys
  CONTENT_STATUS_COMPLETED: "contentStatus.completed",
  CONTENT_STATUS_PLANNED: "contentStatus.planned",
  CONTENT_STATUS_IN_PROGRESS: "contentStatus.inProgress",
  CONTENT_STATUS_CANCELLED: "contentStatus.cancelled",

  // Genre keys
  GENRE_UNSPECIFIED: "genre.unspecified",
  GENRE_ACTION: "genre.action",
  GENRE_ADVENTURE: "genre.adventure",
  GENRE_ANIMATION: "genre.animation",
  GENRE_BIOGRAPHY: "genre.biography",
  GENRE_COMEDY: "genre.comedy",
  GENRE_CRIME: "genre.crime",
  GENRE_DOCUMENTARY: "genre.documentary",
  GENRE_DRAMA: "genre.drama",
  GENRE_FAMILY: "genre.family",
  GENRE_FANTASY: "genre.fantasy",
  GENRE_FILM_NOIR: "genre.filmNoir",
  GENRE_GAME_SHOW: "genre.gameShow",
  GENRE_HISTORY: "genre.history",
  GENRE_HORROR: "genre.horror",
  GENRE_MUSIC: "genre.music",
  GENRE_MUSICAL: "genre.musical",
  GENRE_NEWS: "genre.news",
  GENRE_REALITY_TV: "genre.realityTv",
  GENRE_ROMANCE: "genre.romance",
  GENRE_SCI_FI: "genre.sciFi",
  GENRE_SHORT: "genre.short",
  GENRE_SPORT: "genre.sport",
  GENRE_TALK_SHOW: "genre.talkShow",
  GENRE_THRILLER: "genre.thriller",
  GENRE_WAR: "genre.war",
  GENRE_WESTERN: "genre.western",

  // Platform keys
  PLATFORM_UNSPECIFIED: "platform.unspecified",
  PLATFORM_IMDB: "platform.imdb",
  PLATFORM_KINOPOISK: "platform.kinopoisk",

  // Navigation keys
  NAV_MOVIES: "nav.movies",
  NAV_TV_SHOWS: "nav.tvShows",
  NAV_GAMES: "nav.games",
  NAV_BOOKS: "nav.books",
  NAV_COMICS: "nav.comics",
  NAV_COLLECTIONS: "nav.collections",
  NAV_REVIEWS: "nav.reviews",
  NAV_FAVORITES: "nav.favorites",
  NAV_HISTORY: "nav.history",
  NAV_SETTINGS: "nav.settings",
  NAV_ABOUT: "nav.about",

  // Advanced search keys
  A_SEARCH_BUTTON: "aSearch.button",
  A_SEARCH_CATEGORY: "aSearch.category",
  A_SEARCH_GENRE: "aSearch.genre",
  A_SEARCH_NAME: "aSearch.name",
  A_SEARCH_NAME_PLACEHOLDER: "aSearch.namePlaceholder",
  A_SEARCH_NAME_LABEL: "aSearch.nameLabel",
  A_SEARCH_RELEASE_DATE: "aSearch.releaseDate",
  A_SEARCH_DATE_FROM_PLACEHOLDER: "aSearch.dateFromPlaceholder",
  A_SEARCH_DATE_FROM_LABEL: "aSearch.dateFromLabel",
  A_SEARCH_DATE_TO_PLACEHOLDER: "aSearch.dateToPlaceholder",
  A_SEARCH_DATE_TO_LABEL: "aSearch.dateToLabel",
  A_SEARCH_RATING: "aSearch.rating",
  A_SEARCH_RATING_RANGE: "aSearch.ratingRange",
  A_SEARCH_RATING_PLATFORM_PLACEHOLDER: "aSearch.ratingPlatformPlaceholder",
  A_SEARCH_RATING_PLATFORM_LABEL: "aSearch.ratingPlatformLabel",
  A_SEARCH_RATING_FROM_PLACEHOLDER: "aSearch.ratingFromPlaceholder",
  A_SEARCH_RATING_FROM_LABEL: "aSearch.ratingFromLabel",
  A_SEARCH_RATING_TO_PLACEHOLDER: "aSearch.ratingToPlaceholder",
  A_SEARCH_RATING_TO_LABEL: "aSearch.ratingToLabel",
  A_SEARCH_RATING_INVALID_FORMAT: "aSearch.ratingInvalidFormat",
  A_SEARCH_COUNTRY: "aSearch.country",
  A_SEARCH_COUNTRY_PLACEHOLDER: "aSearch.countryPlaceholder",
  A_SEARCH_COUNTRY_LABEL: "aSearch.countryLabel",
  A_SEARCH_DURATION: "aSearch.duration",
  A_SEARCH_DURATION_FROM_PLACEHOLDER: "aSearch.durationFromPlaceholder",
  A_SEARCH_DURATION_FROM_LABEL: "aSearch.durationFromLabel",
  A_SEARCH_DURATION_TO_PLACEHOLDER: "aSearch.durationToPlaceholder",
  A_SEARCH_DURATION_TO_LABEL: "aSearch.durationToLabel",
  A_SEARCH_DURATION_INVALID_FORMAT: "aSearch.durationInvalidFormat",
  A_SEARCH_PARTICIPANTS: "aSearch.participants",
  A_SEARCH_PARTICIPANTS_PLACEHOLDER: "aSearch.participantsPlaceholder",
  A_SEARCH_PARTICIPANTS_LABEL: "aSearch.participantsLabel",
  A_SEARCH_PARTICIPANTS_MIN_CHARS: "aSearch.participantsMinChars",
  A_SEARCH_FILTERS_TITLE: "aSearch.filtersTitle",
  A_SEARCH_EXPAND_ALL: "aSearch.expandAll",
  A_SEARCH_COLLAPSE_ALL: "aSearch.collapseAll",
  A_SEARCH_STATUS: "aSearch.status",
  A_SEARCH_EMPTY_PLACEHOLDER: "aSearch.emptyPlaceholder",
  A_SEARCH_EMPTY_RESULTS: "aSearch.emptyResults",
  A_SEARCH_CLEAR_FILTERS: "aSearch.clearFilters",

  // Search category keys
  SEARCH_ALL: "search.all",
  SEARCH_CONTENT: "search.content",
  SEARCH_MOVIES: "search.movies",
  SEARCH_TV_SHOWS: "search.tvShows",
  SEARCH_BOOKS: "search.books",
  SEARCH_COMICS: "search.comics",
  SEARCH_GAMES: "search.games",
  SEARCH_USERS: "search.users",
  SEARCH_PERSONS: "search.persons",
  SEARCH_COLLECTIONS: "search.collections",
  SEARCH_FAVORITES: "search.favorites",
  SEARCH_USER: "search.user",
  SEARCH_COMMUNITY: "search.community",
  SEARCH_SEARCHING: "search.searching",
  SEARCH_NO_RESULTS: "search.noResults",
  SEARCH_USER_REPUTATION: "search.userReputation",

  // Notification keys
  NOTIFICATION_JUST_NOW: "notification.justNow",
  NOTIFICATION_MINUTES_AGO: "notification.minutesAgo",
  NOTIFICATION_HOURS_AGO: "notification.hoursAgo",
  NOTIFICATION_DAYS_AGO: "notification.daysAgo",
  NOTIFICATION_WEEKS_AGO: "notification.weeksAgo",
  NOTIFICATION_MONTHS_AGO: "notification.monthsAgo",
  NOTIFICATION_YEARS_AGO: "notification.yearsAgo",
  NOTIFICATION_MARK_ALL_READ: "notification.markAllRead",
  NOTIFICATION_NO_NEW: "notification.noNew",
  NOTIFICATION_UNREAD_COUNT: "notification.unreadCount",
  NOTIFICATION_EMPTY_STATE: "notification.emptyState",
  NOTIFICATION_LOADING_MORE: "notification.loadingMore",
  NOTIFICATION_LOAD_ERROR: "notification.loadError",

  // Content details page keys
  CONTENT_DETAILS_PIN_CONTENT: "contentDetails.pinContent",
  CONTENT_DETAILS_ADD_TO_COLLECTION: "contentDetails.addToCollection",
  CONTENT_DETAILS_CHANGE_CONSUME_TYPE: "contentDetails.changeConsumeType",
  CONTENT_DETAILS_TOGGLE_FAVOURITE: "contentDetails.toggleFavourite",
  CONTENT_DETAILS_OPEN_DISCUSSION: "contentDetails.openDiscussion",
  CONTENT_DETAILS_OPEN_SETTINGS: "contentDetails.openSettings",
  CONTENT_DETAILS_RATE_CONTENT: "contentDetails.rateContent",
  CONTENT_DETAILS_EXTERNAL_RATINGS: "contentDetails.externalRatings",
  CONTENT_DETAILS_CHILD_CONTENT: "contentDetails.childContent",
  CONTENT_DETAILS_REVIEWS: "contentDetails.reviews",
  CONTENT_DETAILS_COLLECTIONS: "contentDetails.collections",
  CONTENT_DETAILS_PARTICIPANTS: "contentDetails.participants",
  CONTENT_DETAILS_GENRES: "contentDetails.genres",
  CONTENT_DETAILS_YOUR_RATING: "contentDetails.yourRating",
  CONTENT_DETAILS_COMMUNITY_RATING: "contentDetails.communityRating",
  CONTENT_DETAILS_RATE_THIS: "contentDetails.rateThis",
  CONTENT_DETAILS_REVIEWS_COUNT: "contentDetails.reviewsCount",
  CONTENT_DETAILS_DESCRIPTION: "contentDetails.description",
  CONTENT_DETAILS_CONTINUE: "contentDetails.continue",
  CONTENT_DETAILS_DURATION_MINUTES: "contentDetails.durationMinutes",
  CONTENT_DETAILS_DURATION_HOURS: "contentDetails.durationHours",
  CONTENT_DETAILS_DURATION_PAGES: "contentDetails.durationPages",
  CONTENT_DETAILS_RELEASE_DATE: "contentDetails.releaseDate",
  CONTENT_DETAILS_STATUS: "contentDetails.status",
  CONTENT_DETAILS_CERTIFICATE: "contentDetails.certificate",
  CONTENT_DETAILS_EPISODE_COUNT: "contentDetails.episodeCount",
  CONTENT_DETAILS_AVG_EPISODE_DURATION: "contentDetails.avgEpisodeDuration",

  // Context menu keys
  CONTEXT_MENU_PIN: "contextMenu.pin",
  CONTEXT_MENU_UNPIN: "contextMenu.unpin",
  CONTEXT_MENU_FAVOURITE: "contextMenu.favourite",
  CONTEXT_MENU_CONSUME: "contextMenu.consume",
  CONTEXT_MENU_SHARE: "contextMenu.share",
  CONTEXT_MENU_REPORT: "contextMenu.report",
  CONTEXT_MENU_LOGOUT: "contextMenu.logout",

  // Affiliate settings keys
  AFFILIATE_SETTINGS_TITLE: "affiliateSettings.title",
  AFFILIATE_SETTINGS_LINK: "affiliateSettings.link",
  AFFILIATE_SETTINGS_LINK_PLACEHOLDER: "affiliateSettings.linkPlaceholder",
  AFFILIATE_SETTINGS_VARIANT: "affiliateSettings.variant",
  AFFILIATE_SETTINGS_VARIANT_PLACEHOLDER:
    "affiliateSettings.variantPlaceholder",
  AFFILIATE_SETTINGS_SAVE: "affiliateSettings.save",
  AFFILIATE_SETTINGS_CANCEL: "affiliateSettings.cancel",

  // Navigator keys
  NAVIGATOR_TITLE: "navigator.title",
  NAVIGATOR_EXPAND_ALL: "navigator.expandAll",
  NAVIGATOR_COLLAPSE_ALL: "navigator.collapseAll",
  NAVIGATOR_EXPAND: "navigator.expand",
  NAVIGATOR_COLLAPSE: "navigator.collapse",
  NAVIGATOR_MARK_WATCHED: "navigator.markWatched",
  NAVIGATOR_RATE: "navigator.rate",

  // Reviews keys
  REVIEWS_USER_HAS_REVIEW: "reviews.userHasReview",
  REVIEWS_NO_REVIEWS: "reviews.noReviews",
  REVIEWS_WRITE_REVIEW: "reviews.writeReview",
  REVIEW_ON: "review.on",
  REVIEWS_SAVE: "reviews.save",
  REVIEWS_CANCEL: "reviews.cancel",
  REVIEWS_PLACEHOLDER: "reviews.placeholder",
  REVIEWS_FORMATTING_BOLD: "reviews.formatting.bold",
  REVIEWS_FORMATTING_ITALIC: "reviews.formatting.italic",
  REVIEWS_FORMATTING_UNDERLINE: "reviews.formatting.underline",
  REVIEWS_FORMATTING_STRIKETHROUGH: "reviews.formatting.strikethrough",
  REVIEWS_FORMATTING_HEADING: "reviews.formatting.heading",
  REVIEWS_FORMATTING_QUOTE: "reviews.formatting.quote",
  REVIEWS_FORMATTING_LIST: "reviews.formatting.list",
  REVIEWS_FORMATTING_LINK: "reviews.formatting.link",
  REVIEWS_VIEW_ALL: "reviews.viewAll",
  REVIEWS_PAGE_TITLE: "reviews.pageTitle",
  REVIEWS_BACK_TO_CONTENT: "reviews.backToContent",
  REVIEWS_SORT_BY_DATE: "reviews.sortByDate",
  REVIEWS_SORT_BY_USEFULNESS: "reviews.sortByUsefulness",
  REVIEWS_SORT_BY_REPUTATION: "reviews.sortByReputation",
  REVIEWS_SORT_ASC: "reviews.sortAsc",
  REVIEWS_SORT_DESC: "reviews.sortDesc",
  REVIEWS_FILTER_LANGUAGE: "reviews.filterLanguage",
  REVIEWS_HIDE_NEGATIVE: "reviews.hideNegative",
  REVIEWS_TOTAL_COUNT: "reviews.totalCount",
  REVIEWS_TITLE: "reviews.title",
  REVIEWS_TITLE_PLACEHOLDER: "reviews.titlePlaceholder",
  REVIEWS_SAVE_ERROR: "reviews.saveError",
  REVIEW_EDIT: "review.edit",
  REVIEW_EDIT_TITLE: "review.editTitle",
  REVIEW_DELETE: "review.delete",
  REVIEW_DELETE_TITLE: "review.deleteTitle",
  REVIEW_DELETE_CONFIRM_MESSAGE: "review.deleteConfirmMessage",
  REVIEW_CONFIRM_DELETE: "review.confirmDelete",
  REVIEW_CONFIRM_DELETE_TEXT: "review.confirmDeleteText",
  REVIEW_CANCEL: "review.cancel",
  REVIEW_AUTHOR_RATING: "review.authorRating",
  REVIEW_CREATED_AT: "review.createdAt",
  REVIEW_UPDATED_AT: "review.updatedAt",
  REVIEW_LOADING: "review.loading",
  REVIEW_ERROR: "review.error",
  REVIEW_NOT_FOUND: "review.notFound",
  REVIEW_GO_TO_CONTENT: "review.goToContent",
  REVIEW_GO_TO_ALL_REVIEWS: "review.goToAllReviews",
  REVIEW_TO_CONTENT: "review.toContent",
  REVIEW_TO_ALL_REVIEWS: "review.toAllReviews",
  REVIEW_OF: "review.of",
  REVIEW_AUTHOR_GAVE_RATING: "review.authorGaveRating",
  REVIEW_COMMENTS_SECTION: "review.commentsSection",
  REVIEW_COMMENTS_PLACEHOLDER: "review.commentsPlaceholder",

  // Comments section keys
  COMMENTS_SECTION_TITLE: "comments.sectionTitle",
  COMMENTS_WRITE_COMMENT: "comments.writeComment",
  COMMENTS_REPLY: "comments.reply",
  COMMENTS_CANCEL: "comments.cancel",
  COMMENTS_PUBLISH: "comments.publish",
  COMMENTS_EDIT: "comments.edit",
  COMMENTS_DELETE: "comments.delete",
  COMMENTS_SHARE: "comments.share",
  COMMENTS_REPORT: "comments.report",
  COMMENTS_VIEW_MORE: "comments.viewMore",
  COMMENTS_LOAD_MORE_REPLIES: "comments.loadMoreReplies",
  COMMENTS_SHOW_REPLIES: "comments.showReplies",
  COMMENTS_HIDE_REPLIES: "comments.hideReplies",
  COMMENTS_REPLY_COUNT: "comments.replyCount",
  COMMENTS_ACTIONS_LABEL: "comments.actionsLabel",
  COMMENTS_EXPAND: "comments.expand",
  COMMENTS_COLLAPSE: "comments.collapse",
  COMMENTS_PLACEHOLDER: "comments.placeholder",
  COMMENTS_CREATED_AT: "comments.createdAt",
  COMMENTS_UPDATED_AT: "comments.updatedAt",
  COMMENTS_EDITED: "comments.edited",
  COMMENTS_DELETE_CONFIRM: "comments.deleteConfirm",
  COMMENTS_DELETE_CONFIRM_MESSAGE: "comments.deleteConfirmMessage",
  COMMENTS_SAVE_ERROR: "comments.saveError",
  COMMENTS_DELETE_ERROR: "comments.deleteError",
  COMMENTS_LOAD_ERROR: "comments.loadError",
  COMMENTS_NO_COMMENTS: "comments.noComments",
  COMMENTS_REPLYING_TO: "comments.replyingTo",

  // Favourites action keys
  FAVOURITES_FAVOURITE: "favourites.favourite",
  FAVOURITES_MUTE: "favourites.mute",
  FAVOURITES_UNMUTE: "favourites.unmute",
  FAVOURITES_UNFAVOURITE: "favourites.unfavourite",

  // Add to collection popup keys
  ADD_TO_COLLECTION_TITLE: "addToCollection.title",
  ADD_TO_COLLECTION_CREATE_NEW: "addToCollection.createNew",
  CREATE_COLLECTION_TITLE: "createCollection.title",
  CREATE_COLLECTION_BUTTON: "createCollection.button",
  ADD_TO_COLLECTION_NO_COLLECTIONS: "addToCollection.noCollections",
  ADD_TO_COLLECTION_LOADING: "addToCollection.loading",
  ADD_TO_COLLECTION_ERROR: "addToCollection.error",
  ADD_TO_COLLECTION_SUCCESS: "addToCollection.success",

  // Collection item keys
  COLLECTION_AUTHOR_NOTE: "collection.authorNote",
  COLLECTION_NOTE_PLACEHOLDER: "collection.notePlaceholder",

  // Collection form keys
  COLLECTION_TITLE: "collection.title",
  COLLECTION_TITLE_PLACEHOLDER: "collection.titlePlaceholder",
  COLLECTION_DESCRIPTION: "collection.description",
  COLLECTION_DESCRIPTION_PLACEHOLDER: "collection.descriptionPlaceholder",
  COLLECTION_IMAGE_URL: "collection.imageUrl",
  COLLECTION_IMAGE_URL_PLACEHOLDER: "collection.imageUrlPlaceholder",

  // Collection delete keys
  COLLECTION_DELETE_TITLE: "collection.deleteTitle",
  COLLECTION_DELETE_CONFIRM_MESSAGE: "collection.deleteConfirmMessage",

  // Region keys
  REGION_UNSPECIFIED: "region.unspecified",
  // Europe
  REGION_RUSSIA: "region.russia",
  REGION_UNITED_KINGDOM: "region.unitedKingdom",
  REGION_GERMANY: "region.germany",
  REGION_FRANCE: "region.france",
  REGION_ITALY: "region.italy",
  REGION_SPAIN: "region.spain",
  REGION_POLAND: "region.poland",
  REGION_UKRAINE: "region.ukraine",
  REGION_NETHERLANDS: "region.netherlands",
  REGION_BELGIUM: "region.belgium",
  REGION_SWEDEN: "region.sweden",
  REGION_SWITZERLAND: "region.switzerland",
  REGION_AUSTRIA: "region.austria",
  REGION_DENMARK: "region.denmark",
  REGION_NORWAY: "region.norway",
  REGION_FINLAND: "region.finland",
  REGION_PORTUGAL: "region.portugal",
  REGION_GREECE: "region.greece",
  REGION_IRELAND: "region.ireland",
  REGION_CZECH_REPUBLIC: "region.czechRepublic",
  REGION_HUNGARY: "region.hungary",
  REGION_ROMANIA: "region.romania",
  REGION_BULGARIA: "region.bulgaria",
  REGION_SLOVAKIA: "region.slovakia",
  REGION_CROATIA: "region.croatia",
  REGION_SERBIA: "region.serbia",
  REGION_BOSNIA_AND_HERZEGOVINA: "region.bosniaAndHerzegovina",
  REGION_ALBANIA: "region.albania",
  REGION_LITHUANIA: "region.lithuania",
  REGION_LATVIA: "region.latvia",
  REGION_ESTONIA: "region.estonia",
  REGION_SLOVENIA: "region.slovenia",
  REGION_NORTH_MACEDONIA: "region.northMacedonia",
  REGION_MONTENEGRO: "region.montenegro",
  REGION_KOSOVO: "region.kosovo",
  REGION_MOLDOVA: "region.moldova",
  REGION_BELARUS: "region.belarus",
  REGION_LUXEMBOURG: "region.luxembourg",
  REGION_ICELAND: "region.iceland",
  REGION_ANDORRA: "region.andorra",
  REGION_MONACO: "region.monaco",
  REGION_LIECHTENSTEIN: "region.liechtenstein",
  REGION_SAN_MARINO: "region.sanMarino",
  REGION_MALTA: "region.malta",
  REGION_CYPRUS: "region.cyprus",
  REGION_TURKEY: "region.turkey",
  REGION_ISRAEL: "region.israel",
  // Americas
  REGION_UNITED_STATES: "region.unitedStates",
  REGION_CANADA: "region.canada",
  REGION_MEXICO: "region.mexico",
  REGION_BRAZIL: "region.brazil",
  REGION_ARGENTINA: "region.argentina",
  REGION_CHILE: "region.chile",
  REGION_COLOMBIA: "region.colombia",
  REGION_PERU: "region.peru",
  REGION_VENEZUELA: "region.venezuela",
  REGION_ECUADOR: "region.ecuador",
  REGION_BOLIVIA: "region.bolivia",
  REGION_PARAGUAY: "region.paraguay",
  REGION_URUGUAY: "region.uruguay",
  REGION_COSTA_RICA: "region.costaRica",
  REGION_PANAMA: "region.panama",
  REGION_GUATEMALA: "region.guatemala",
  REGION_EL_SALVADOR: "region.elSalvador",
  REGION_HONDURAS: "region.honduras",
  REGION_NICARAGUA: "region.nicaragua",
  REGION_DOMINICAN_REPUBLIC: "region.dominicanRepublic",
  REGION_CUBA: "region.cuba",
  REGION_HAITI: "region.haiti",
  REGION_JAMAICA: "region.jamaica",
  REGION_TRINIDAD_AND_TOBAGO: "region.trinidadAndTobago",
  REGION_BAHAMAS: "region.bahamas",
  REGION_BARBADOS: "region.barbados",
  REGION_SAINT_LUCIA: "region.saintLucia",
  REGION_ANTIGUA_AND_BARBUDA: "region.antiguaAndBarbuda",
  REGION_DOMINICA: "region.dominica",
  REGION_GRENADA: "region.grenada",
  REGION_SAINT_KITTS_AND_NEVIS: "region.saintKittsAndNevis",
  REGION_SAINT_VINCENT_AND_THE_GRENADINES:
    "region.saintVincentAndTheGrenadines",
  REGION_BELIZE: "region.belize",
  REGION_GUYANA: "region.guyana",
  REGION_SURINAME: "region.suriname",
  // Asia
  REGION_CHINA: "region.china",
  REGION_JAPAN: "region.japan",
  REGION_SOUTH_KOREA: "region.southKorea",
  REGION_INDIA: "region.india",
  REGION_INDONESIA: "region.indonesia",
  REGION_PHILIPPINES: "region.philippines",
  REGION_VIETNAM: "region.vietnam",
  REGION_THAILAND: "region.thailand",
  REGION_MALAYSIA: "region.malaysia",
  REGION_SINGAPORE: "region.singapore",
  REGION_PAKISTAN: "region.pakistan",
  REGION_BANGLADESH: "region.bangladesh",
  REGION_SRI_LANKA: "region.sriLanka",
  REGION_NEPAL: "region.nepal",
  REGION_MYANMAR: "region.myanmar",
  REGION_CAMBODIA: "region.cambodia",
  REGION_LAOS: "region.laos",
  REGION_BRUNEI: "region.brunei",
  REGION_MONGOLIA: "region.mongolia",
  REGION_NORTH_KOREA: "region.northKorea",
  REGION_TAIWAN: "region.taiwan",
  REGION_HONG_KONG: "region.hongKong",
  REGION_MACAU: "region.macau",
  REGION_KAZAKHSTAN: "region.kazakhstan",
  REGION_UZBEKISTAN: "region.uzbekistan",
  REGION_TURKMENISTAN: "region.turkmenistan",
  REGION_KYRGYZSTAN: "region.kyrgyzstan",
  REGION_TAJIKISTAN: "region.tajikistan",
  REGION_AFGHANISTAN: "region.afghanistan",
  REGION_MALDIVES: "region.maldives",
  REGION_BHUTAN: "region.bhutan",
  REGION_TIMOR_LESTE: "region.timorLeste",
  // Middle East
  REGION_UNITED_ARAB_EMIRATES: "region.unitedArabEmirates",
  REGION_SAUDI_ARABIA: "region.saudiArabia",
  REGION_IRAN: "region.iran",
  REGION_IRAQ: "region.iraq",
  REGION_SYRIA: "region.syria",
  REGION_LEBANON: "region.lebanon",
  REGION_JORDAN: "region.jordan",
  REGION_YEMEN: "region.yemen",
  REGION_OMAN: "region.oman",
  REGION_QATAR: "region.qatar",
  REGION_KUWAIT: "region.kuwait",
  REGION_BAHRAIN: "region.bahrain",
  REGION_PALESTINE: "region.palestine",
  // Africa
  REGION_EGYPT: "region.egypt",
  REGION_NIGERIA: "region.nigeria",
  REGION_SOUTH_AFRICA: "region.southAfrica",
  REGION_KENYA: "region.kenya",
  REGION_GHANA: "region.ghana",
  REGION_ALGERIA: "region.algeria",
  REGION_MOROCCO: "region.morocco",
  REGION_ETHIOPIA: "region.ethiopia",
  REGION_TANZANIA: "region.tanzania",
  REGION_UGANDA: "region.uganda",
  REGION_SUDAN: "region.sudan",
  REGION_TUNISIA: "region.tunisia",
  REGION_LIBYA: "region.libya",
  REGION_ANGOLA: "region.angola",
  REGION_CAMEROON: "region.cameroon",
  REGION_IVORY_COAST: "region.ivoryCoast",
  REGION_MADAGASCAR: "region.madagascar",
  REGION_SENEGAL: "region.senegal",
  REGION_ZIMBABWE: "region.zimbabwe",
  REGION_MOZAMBIQUE: "region.mozambique",
  REGION_ZAMBIA: "region.zambia",
  REGION_MALAWI: "region.malawi",
  REGION_BURKINA_FASO: "region.burkinaFaso",
  REGION_MALI: "region.mali",
  REGION_NIGER: "region.niger",
  REGION_CHAD: "region.chad",
  REGION_SOMALIA: "region.somalia",
  REGION_ERITREA: "region.eritrea",
  REGION_RWANDA: "region.rwanda",
  REGION_BURUNDI: "region.burundi",
  REGION_BENIN: "region.benin",
  REGION_TOGO: "region.togo",
  REGION_GUINEA: "region.guinea",
  REGION_SIERRA_LEONE: "region.sierraLeone",
  REGION_LIBERIA: "region.liberia",
  REGION_CENTRAL_AFRICAN_REPUBLIC: "region.centralAfricanRepublic",
  REGION_CONGO_DEMOCRATIC_REPUBLIC: "region.congoDemocraticRepublic",
  REGION_CONGO: "region.congo",
  REGION_GABON: "region.gabon",
  REGION_EQUATORIAL_GUINEA: "region.equatorialGuinea",
  REGION_SAO_TOME_AND_PRINCIPE: "region.saoTomeAndPrincipe",
  REGION_MAURITIUS: "region.mauritius",
  REGION_SEYCHELLES: "region.seychelles",
  REGION_COMOROS: "region.comoros",
  REGION_CAPE_VERDE: "region.capeVerde",
  REGION_ESWATINI: "region.eswatini",
  REGION_LESOTHO: "region.lesotho",
  REGION_BOTSWANA: "region.botswana",
  REGION_NAMIBIA: "region.namibia",
  REGION_SOUTH_SUDAN: "region.southSudan",
  REGION_DJIBOUTI: "region.djibouti",
  REGION_MAURITANIA: "region.mauritania",
  REGION_GAMBIA: "region.gambia",
  REGION_GUINEA_BISSAU: "region.guineaBissau",
  // Oceania
  REGION_AUSTRALIA: "region.australia",
  REGION_NEW_ZEALAND: "region.newZealand",
  REGION_PAPUA_NEW_GUINEA: "region.papuaNewGuinea",
  REGION_FIJI: "region.fiji",
  REGION_SOLOMON_ISLANDS: "region.solomonIslands",
  REGION_VANUATU: "region.vanuatu",
  REGION_SAMOA: "region.samoa",
  REGION_TONGA: "region.tonga",
  REGION_KIRIBATI: "region.kiribati",
  REGION_MICRONESIA: "region.micronesia",
  REGION_PALAU: "region.palau",
  REGION_MARSHALL_ISLANDS: "region.marshallIslands",
  REGION_NAURU: "region.nauru",
  REGION_TUVALU: "region.tuvalu",

  // Person page keys
  PERSON_BIRTH_DATE: "person.birthDate",
  PERSON_DEATH_DATE: "person.deathDate",
  PERSON_AGE: "person.age",
  PERSON_YEARS: "person.years",
  PERSON_GENDER: "person.gender",
  PERSON_HEIGHT: "person.height",
  PERSON_HEIGHT_CM: "person.heightCm",
  PERSON_BIRTH_PLACE: "person.birthPlace",
  PERSON_SPOUSE: "person.spouse",
  PERSON_BIOGRAPHY: "person.biography",
  PERSON_KNOWN_FOR: "person.knownFor",
  PERSON_PARTICIPATED_IN: "person.participatedIn",
  PERSON_FAVOURITE_COUNT: "person.favouriteCount",
  PERSON_MESSAGE_COUNT: "person.messageCount",

  // Position Type keys
  POSITION_TYPE_UNSPECIFIED: "positionType.unspecified",
  POSITION_TYPE_DIRECTOR: "positionType.director",
  POSITION_TYPE_WRITER: "positionType.writer",
  POSITION_TYPE_ACTOR: "positionType.actor",
  POSITION_TYPE_PRODUCER: "positionType.producer",
  POSITION_TYPE_CINEMATOGRAPHER: "positionType.cinematographer",
  POSITION_TYPE_EDITOR: "positionType.editor",
  POSITION_TYPE_COMPOSER: "positionType.composer",
  POSITION_TYPE_VOICE_ACTOR: "positionType.voiceActor",

  // Pagination keys
  PAGINATION_PREVIOUS: "pagination.previous",
  PAGINATION_NEXT: "pagination.next",
  PAGINATION_FIRST: "pagination.first",
  PAGINATION_LAST: "pagination.last",

  // Sort keys
  SORT_BY: "sort.by",
  SORT_BY_NEWEST: "sort.byNewest",
  SORT_BY_OLDEST: "sort.byOldest",
  SORT_BY_POPULAR: "sort.byPopular",
  SORT_BY_RATING: "sort.byRating",
  SORT_NEWEST: "sort.newest",
  SORT_OLDEST: "sort.oldest",
  SORT_HIGHEST_REPUTATION: "sort.highestReputation",
  SORT_LOWEST_REPUTATION: "sort.lowestReputation",
  SORT_MOST_USEFUL: "sort.mostUseful",
  SORT_LEAST_USEFUL: "sort.leastUseful",
  SORT_HIGHEST_RATING: "sort.highestRating",
  SORT_LOWEST_RATING: "sort.lowestRating",
  SORT_NAME_ASC: "sort.nameAsc",
  SORT_NAME_DESC: "sort.nameDesc",

  // Collections list keys
  COLLECTIONS_NO_COLLECTIONS_FOUND: "collections.noCollectionsFound",
  COLLECTIONS_LOADING: "collections.loading",
  COLLECTIONS_ONLY_MY_COLLECTIONS: "collections.onlyMyCollections",
  COLLECTIONS_OF_CONTENT: "collections.ofContent",
  COLLECTIONS_TO_ALL_COLLECTIONS: "collections.toAllCollections",

  // User collections page keys
  USER_COLLECTIONS_TOTAL: "userCollections.total",
  USER_COLLECTIONS_AVG_REPUTATION: "userCollections.avgReputation",
  USER_COLLECTIONS_TOTAL_FAVOURITES: "userCollections.totalFavourites",
  USER_COLLECTIONS_TOTAL_COMMENTS: "userCollections.totalComments",
  USER_COLLECTIONS_EMPTY: "userCollections.empty",
  USER_COLLECTIONS_TITLE: "userCollections.title",
  USER_COLLECTIONS_SORT_BY_DATE: "userCollections.sortByDate",
  USER_COLLECTIONS_SORT_BY_REPUTATION: "userCollections.sortByReputation",
  USER_COLLECTIONS_SORT_BY_USEFULNESS: "userCollections.sortByUsefulness",

  // User profile page keys
  USER_PAGE_FOLLOW: "userPage.follow",
  USER_PAGE_FOLLOWING: "userPage.following",
  USER_PAGE_UNFOLLOW: "userPage.unfollow",
  USER_PAGE_FOLLOWERS: "userPage.followers",
  USER_PAGE_REVIEWS: "userPage.reviews",
  USER_PAGE_COLLECTIONS: "userPage.collections",
  USER_PAGE_LIBRARY: "userPage.library",
  USER_PAGE_MY_LIBRARY: "userPage.myLibrary",
  USER_PAGE_FAVOURITES: "userPage.favourites",
  USER_PAGE_MY_FAVOURITES: "userPage.myFavourites",
  USER_PAGE_CREATED_COLLECTIONS: "userPage.createdCollections",
  USER_PAGE_VIEW_ALL_COLLECTIONS: "userPage.viewAllCollections",
  USER_PAGE_TOP_REVIEWS: "userPage.topReviews",
  USER_PAGE_VIEW_ALL_REVIEWS: "userPage.viewAllReviews",
  USER_PAGE_ACTIVITY_CALENDAR: "userPage.activityCalendar",
  USER_PAGE_ACTIVITY_CALENDAR_DESC: "userPage.activityCalendarDesc",
  USER_PAGE_PLATFORM_HISTORY: "userPage.platformHistory",
  USER_PAGE_PLATFORM_HISTORY_DESC: "userPage.platformHistoryDesc",
  USER_PAGE_ACIVEMENT_SECTION: "userPage.achivementSection",
  USER_PAGE_ACIVEMENT_SECTION_DESC: "userPage.achivementSectionDesc",

  // User follows page keys
  USER_FOLLOWS_PAGE_FOLLOWERS_TAB: "userFollowsPage.followersTab",
  USER_FOLLOWS_PAGE_FOLLOWING_TAB: "userFollowsPage.followingTab",
  USER_FOLLOWS_PAGE_NO_FOLLOWERS: "userFollowsPage.noFollowers",
  USER_FOLLOWS_PAGE_NO_FOLLOWING: "userFollowsPage.noFollowing",
  USER_FOLLOWS_PAGE_LOADING: "userFollowsPage.loading",

  // User stats keys
  USER_STATS_OVERVIEW: "userStats.overview",
  USER_STATS_REVIEWS: "userStats.reviews",
  USER_STATS_COLLECTIONS: "userStats.collections",
  USER_STATS_COMMENTS: "userStats.comments",
  USER_STATS_FAVOURITES: "userStats.favourites",
  USER_STATS_TOTAL_CONSUMED: "userStats.totalConsumed",
  USER_STATS_ITEMS: "userStats.items",
  USER_STATS_WATCH_TIME: "userStats.watchTime",
  USER_STATS_PAGES_READ: "userStats.pagesRead",
  USER_STATS_DAYS: "userStats.days",
  USER_STATS_HOURS: "userStats.hours",
  USER_STATS_MINUTES: "userStats.minutes",
  USER_STATS_PAGES: "userStats.pages",

  // Favourite widget keys
  FAVOURITE_WIDGET_NO_CONTENT: "favouriteWidget.noContent",
  FAVOURITE_WIDGET_NO_CONTENT_CURRENT_USER:
    "favouriteWidget.noContentCurrentUser",
  FAVOURITE_WIDGET_NO_PEOPLE: "favouriteWidget.noPeople",
  FAVOURITE_WIDGET_NO_PEOPLE_CURRENT_USER:
    "favouriteWidget.noPeopleCurrentUser",
  FAVOURITE_WIDGET_NO_COLLECTIONS: "favouriteWidget.noCollections",
  FAVOURITE_WIDGET_NO_COLLECTIONS_CURRENT_USER:
    "favouriteWidget.noCollectionsCurrentUser",

  // Library widget keys
  LIBRARY_WIDGET_NO_CONTENT: "libraryWidget.noContent",
  LIBRARY_WIDGET_NO_CONTENT_CURRENT_USER: "libraryWidget.noContentCurrentUser",

  // Toast notification keys
  TOAST_AUTH_WELCOME_BACK: "toast.auth.welcomeBack",
  TOAST_AUTH_ACCOUNT_CREATED: "toast.auth.accountCreated",
  TOAST_AUTH_SESSION_EXPIRED: "toast.auth.sessionExpired",
  TOAST_AUTH_PROFILE_LOAD_FAILED: "toast.auth.profileLoadFailed",

  TOAST_DEV_MOCK_DATA_LOADED: "toast.dev.mockDataLoaded",

  TOAST_REVIEW_CREATED: "toast.review.created",
  TOAST_REVIEW_SAVED: "toast.review.saved",
  TOAST_REVIEW_FILL_REQUIRED: "toast.review.fillRequired",

  TOAST_COLLECTION_SAVED: "toast.collection.saved",
  TOAST_COLLECTION_UPDATED: "toast.collection.updated",
  TOAST_COLLECTION_DELETED: "toast.collection.deleted",
  TOAST_COLLECTION_TITLE_REQUIRED: "toast.collection.titleRequired",

  TOAST_AFFILIATE_SAVED: "toast.affiliate.saved",

  TOAST_ERROR_GENERIC: "toast.error.generic",
  TOAST_ERROR_NETWORK: "toast.error.network",
  TOAST_ERROR_SAVE_FAILED: "toast.error.saveFailed",

  TOAST_VALIDATION_REQUIRED_FIELDS: "toast.validation.requiredFields",
  TOAST_VALIDATION_FILL_ALL_FIELDS: "toast.validation.fillAllFields",

  // Pin action toast keys
  TOAST_CONTENT_PINNED: "toast.content.pinned",
  TOAST_CONTENT_UNPINNED: "toast.content.unpinned",
  TOAST_CONTENT_PIN_ERROR: "toast.content.pinError",
  TOAST_CONTENT_UNPIN_ERROR: "toast.content.unpinError",

  // Follow action toast keys
  TOAST_USER_FOLLOWED: "toast.user.followed",
  TOAST_USER_UNFOLLOWED: "toast.user.unfollowed",
  TOAST_USER_FOLLOW_ERROR: "toast.user.followError",
  TOAST_USER_UNFOLLOW_ERROR: "toast.user.unfollowError",

  // Edit/Delete action toast keys
  TOAST_ITEM_DELETED: "toast.item.deleted",
  TOAST_ITEM_DELETE_ERROR: "toast.item.deleteError",
  TOAST_ITEM_UPDATED: "toast.item.updated",
  TOAST_ITEM_UPDATE_ERROR: "toast.item.updateError",

  // Favourite action toast keys
  TOAST_FAVOURITE_ADDED: "toast.favourite.added",
  TOAST_FAVOURITE_REMOVED: "toast.favourite.removed",
  TOAST_FAVOURITE_MUTED: "toast.favourite.muted",
  TOAST_FAVOURITE_UNMUTED: "toast.favourite.unmuted",
  TOAST_FAVOURITE_ADD_ERROR: "toast.favourite.addError",
  TOAST_FAVOURITE_REMOVE_ERROR: "toast.favourite.removeError",
  TOAST_FAVOURITE_UPDATE_ERROR: "toast.favourite.updateError",

  // Rating action toast keys
  TOAST_RATING_ADDED: "toast.rating.added",
  TOAST_RATING_UPDATED: "toast.rating.updated",
  TOAST_RATING_REMOVED: "toast.rating.removed",
  TOAST_RATING_ERROR: "toast.rating.error",

  // Consume action toast keys
  TOAST_CONSUME_WATCHING: "toast.consume.watching",
  TOAST_CONSUME_WATCHED: "toast.consume.watched",
  TOAST_CONSUME_DELAYED: "toast.consume.delayed",
  TOAST_CONSUME_TRASH: "toast.consume.trash",
  TOAST_CONSUME_REMOVED: "toast.consume.removed",
  TOAST_CONSUME_ERROR: "toast.consume.error",

  // Reputation action toast keys
  TOAST_REPUTATION_LIKED: "toast.reputation.liked",
  TOAST_REPUTATION_DISLIKED: "toast.reputation.disliked",
  TOAST_REPUTATION_REMOVED: "toast.reputation.removed",
  TOAST_REPUTATION_ERROR: "toast.reputation.error",

  // Share action toast keys
  TOAST_LINK_COPIED: "toast.share.linkCopied",
  TOAST_LINK_COPY_ERROR: "toast.share.linkCopyError",
} as const;

export type LocalizationKey =
  (typeof LocalizationKeys)[keyof typeof LocalizationKeys];

/**
 * Type for partial translation objects (e.g., region-only translations)
 * Allows using LocalizationKey type while only requiring a subset of keys
 */
export type PartialTranslations = Partial<Record<LocalizationKey, string>>;

/**
 * Type for complete translation objects
 * Requires all LocalizationKey keys to be present
 */
export type Translations = Record<LocalizationKey, string>;
